import React from 'react';
import styled, { css } from 'styled-components';
import { observer } from 'mobx-react-lite';
import mergeClassNames from '../../lib/style-helpers/merge-class-name';
import { UIProps } from '../../types/StyledProps';

type ProgressBarProps = {
  progress: number;
} & UIProps;

function ProgressBar({
  progress = 0,
  delay = 0,
  ...props
}: React.PropsWithoutRef<ProgressBarProps>) {
  return (
    <Container
      className={mergeClassNames('ProgressBar', props.className)}
      progress={progress}
      delay={delay}
      {...props}
    >
      <span>
        <span />
      </span>
    </Container>
  );
}

export default observer(ProgressBar);

const Container = styled.div < ProgressBarProps > `
  box-sizing: content-box;
  height: 10px;
  background: white;
  position: absolute;
  left: 0;
  bottom: 0;
  border-radius: 0;
  ${({ delay, progress }) => css`
    width: ${progress}%;
    opacity: ${progress === 100
    ? 0
    : 1};
    transition: opacity 250ms ease ${(delay ?? 0) + .75}s, width 1s linear;
  `}
  > span {
    display: block;
    height: 100%;
    border-radius: 0;
    background-color: ${({ theme }) => theme.colors.primary};
    background-image: linear-gradient(center bottom,
    ${({ theme }) => theme.colors.primary} 37%,
    ${({ theme }) => theme.colors.primary} 69%);
    position: relative;
    overflow: hidden;
  }

  > span > span,
  > span:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background-image: linear-gradient(-45deg,
    rgba(255, 255, 255, 0.2) 25%,
    transparent 25%,
    transparent 50%,
    rgba(255, 255, 255, 0.2) 50%,
    rgba(255, 255, 255, 0.2) 75%,
    transparent 75%,
    transparent);
    z-index: 1;
    background-size: 100px 100px;
    animation: move 2s linear infinite;
    border-radius: 0;
    overflow: hidden;
    @keyframes move {
      0% {
        background-position: 0 0;
      }
      100% {
        background-position: 100px 100px;
      }
    }
  }

`;
